var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#FAD1C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3141 8.064C14.7088 8.064 15.0448 8.208 15.3221 8.496C15.6101 8.77333 15.7541 9.11467 15.7541 9.52V19.184C15.7541 19.408 15.6741 19.6 15.5141 19.76C15.3648 19.92 15.1728 20 14.9381 20H14.6661C14.4421 20 14.2501 19.92 14.0901 19.76C13.9301 19.6 13.8501 19.408 13.8501 19.184V10.096L12.6821 10.736C12.5648 10.8107 12.4261 10.848 12.2661 10.848C12.0421 10.848 11.8501 10.7733 11.6901 10.624C11.5408 10.464 11.4661 10.2613 11.4661 10.016C11.4661 9.76 11.5835 9.552 11.8181 9.392L13.4821 8.336C13.7488 8.15467 14.0261 8.064 14.3141 8.064Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.1a2a5907fdbf1f479be706f37ccc0d58.svg";
export { ForwardRef as ReactComponent };